import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import TextField from '@insided/deprecated-preact-components/design-system-components/text-field'
import Dropdown, {
  DropdownItem
  // eslint-disable-next-line import/no-internal-modules
} from '@insided/deprecated-preact-components/design-system-components/dropdown'
import objectKeys from '@insided/shared/utils/objectKeys'
import Button from '@insided/control/uikit/Button'

export const CONTENT_TYPES = {
  all: 'All content types',
  question: 'Questions',
  conversation: 'Conversations',
  article: 'Articles',
  idea: 'Ideas',
  productUpdate: 'Product Updates'
} as const

export const SORT_OPTIONS = {
  views: 'Number of views',
  lastActivityAt: 'Last activity',
  replyCount: 'Reply Count'
} as const

interface Content {
  maxNumberOfItems?: number
  buttonLabel?: string
  buttonURL?: string
  selectedContentType: keyof typeof CONTENT_TYPES
  selectedSortType: keyof typeof SORT_OPTIONS
}

interface NewData {
  maxNumberOfItems: number
  buttonLabel: string
  buttonURL: string
  selectedContentType: keyof typeof CONTENT_TYPES
  selectedSortType: keyof typeof SORT_OPTIONS
}

interface DynamicContentConfiguratorProps {
  onChange: (state: NewData) => void
  content: Content
}

interface State {
  selectedContentType: keyof typeof CONTENT_TYPES
  selectedSortType: keyof typeof SORT_OPTIONS
  maxNumberOfItems: number
  buttonLabel: string
  buttonURL: string
}

export class DynamicContentConfigurator extends Component<DynamicContentConfiguratorProps, State> {
  constructor(props: DynamicContentConfiguratorProps) {
    super(props)

    this.state = {
      selectedSortType: props.content.selectedSortType ?? 'lastActivityAt',
      selectedContentType: props.content.selectedContentType ?? 'all',
      maxNumberOfItems: props.content.maxNumberOfItems ?? 5,
      buttonLabel: props.content.buttonLabel ?? '',
      buttonURL: props.content.buttonURL ?? ''
    }

    this.onChangeContentType = this.onChangeContentType.bind(this)
    this.onChangeSortType = this.onChangeSortType.bind(this)
    this.onChangeButtonLabel = this.onChangeButtonLabel.bind(this)
    this.onChangeButtonURL = this.onChangeButtonURL.bind(this)
    this.onChangeSend = this.onChangeSend.bind(this)
  }

  onChangeButtonLabel(newButtonLabel: string) {
    this.setState(
      {
        buttonLabel: newButtonLabel
      },
      this.onChangeSend
    )
  }

  onChangeButtonURL(newButtonURL: string) {
    this.setState(
      {
        buttonURL: newButtonURL
      },
      this.onChangeSend
    )
  }

  onChangeContentType(contentType: keyof typeof CONTENT_TYPES) {
    this.setState({ selectedContentType: contentType }, () => this.onChangeSend())
  }

  onChangeSortType(sortType: keyof typeof SORT_OPTIONS) {
    this.setState({ selectedSortType: sortType }, () => this.onChangeSend())
  }

  onChangeNumberOfItems(newNumber: number) {
    this.setState({ maxNumberOfItems: newNumber }, () => this.onChangeSend())
  }

  onChangeSend() {
    const newData: NewData = {
      maxNumberOfItems: this.state.maxNumberOfItems,
      buttonLabel: this.state.buttonLabel,
      buttonURL: this.state.buttonURL,
      selectedContentType: this.state.selectedContentType,
      selectedSortType: this.state.selectedSortType
    }

    this.props.onChange(newData)
  }

  render() {
    const { selectedContentType, selectedSortType, maxNumberOfItems, buttonURL, buttonLabel } =
      this.state
    return (
      <div className='dynamic-content-widget-selections'>
        <TextField
          name='dynamic_content_max_number_of_items'
          label='Maximum number of item to display'
          ariaLabel='Maximum number of item to display'
          id='dynamic_content_max_number_of_items'
          defaultValue={maxNumberOfItems}
          onChange={(newValue) => {
            this.onChangeNumberOfItems(parseInt(newValue))
          }}
          onKeyUp={(newValue) => {
            this.onChangeNumberOfItems(parseInt(newValue))
          }}
          type='number'
          isControl
        />
        <Dropdown
          size='full-width'
          textButtonStyle={{
            width: '100%'
          }}
          closeOnDropdownClick
          popupName='dynamic-content-widget_content-type-selection'
          trigger={
            <div className='dynamic-content-widget_dropdown-selection'>
              <label>Content type</label>
              <Button
                icon='arrowDropdown'
                title={CONTENT_TYPES[selectedContentType]}
                fullWidth
                size='medium'
              />
            </div>
          }
        >
          {objectKeys(CONTENT_TYPES).map((contentType) => (
            <DropdownItem onClick={() => this.onChangeContentType(contentType)} key={contentType}>
              {CONTENT_TYPES[contentType]}
            </DropdownItem>
          ))}
        </Dropdown>
        <Dropdown
          size='full-width'
          textButtonStyle={{
            width: '100%'
          }}
          closeOnDropdownClick
          popupName='dynamic-content-widget_sort_type_selection'
          trigger={
            <div className='dynamic-content-widget_dropdown-selection'>
              <label>Sort by</label>
              <Button
                icon='arrowDropdown'
                title={SORT_OPTIONS[selectedSortType]}
                fullWidth
                size='medium'
              />
            </div>
          }
        >
          {objectKeys(SORT_OPTIONS).map((sortType) => (
            <DropdownItem
              onClick={() => this.onChangeSortType(sortType)}
              key={sortType}
            >
              {SORT_OPTIONS[sortType]}
            </DropdownItem>
          ))}
        </Dropdown>

        <TextField
          placeholder='Show more'
          name='dynamic_content_button_label'
          label='Button label (optional)'
          ariaLabel='Button label (optional)'
          id='dynamic_content_button_label'
          defaultValue={buttonLabel}
          onChange={(newValue) => {
            this.onChangeButtonLabel(newValue)
          }}
          isControl
        />

        <TextField
          placeholder='https://example.com'
          name='dynamic_content_button_url'
          label='URL (optional)'
          ariaLabel='URL (optional)'
          id='dynamic_content_button_url'
          defaultValue={buttonURL}
          onChange={(newValue) => {
            this.onChangeButtonURL(newValue)
          }}
          isControl
        />
      </div>
    )
  }
}

export default DynamicContentConfigurator
